import { getAppData } from '../../lib/api/common';
import { getPodcastsPage } from '../../lib/api/podcasts';

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import Page from '../../components/content/page/Page'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

export type PodcastsProps = {
	page: any
	app: any,
	updatesPage: any
}


export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const data: any = await getPodcastsPage(
		context.preview ? context.previewData?.token : undefined
	);
	
	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			updatesPage: data ? data.updatesPage : null
		},
		revalidate: revalidateSeconds()
	};
}



export default function Podcasts(props: PodcastsProps) {

	const { app, page, updatesPage } = props

	const breadcrumbs = [
		{
			id: updatesPage.id,
			title: updatesPage.title,
			uri: updatesPage.uri,
		},
		{
			id: page.id,
			title: page.title,
			uri: null,
		}
	]

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={breadcrumbs}
			>
				<>
					<Page page={page} />
				</>
			</Layout>
		</>
	)
}
